import Reveal from "./Reveal";

export default function GalleryGrid({ images, columns = 4, testIdPrefix = "gallery" }) {
  const colsClass =
    columns === 2
      ? "grid-cols-1 md:grid-cols-2"
      : "grid-cols-1 md:grid-cols-2 lg:grid-cols-4";

  return (
    <div className={`grid ${colsClass} gap-6`} data-testid={`${testIdPrefix}-grid`}>
      {images.map((src, idx) => (
        <Reveal key={idx} delay={idx * 80} className="cc-gallery-card aspect-[4/5]" data-testid={`${testIdPrefix}-item-${idx}`}>
          <img src={src} alt={`${testIdPrefix} ${idx + 1}`} className="w-full h-full object-cover" loading="lazy" />
        </Reveal>
      ))}
    </div>
  );
}
